import React, { Component } from 'react';
import $ from 'jquery';
import ChatActionType from '../../enums/action-types/ChatActionType';
import GlobalStoreService from "../../services/global-store.service";
import PlatformType from '../../enums/PlatformType';
import { globalConstants } from '../../constants/globalConstants'
import UserActionClass from '../../objectClasses/user-action-class';
import UserActionType from '../../enums/UserActionType';


const AlternateNumberInputComponent = ({ props, setBottomBarComponentState, onSkipClick, handleUserAction }) => {
    let handleOptionsClick = props.handleOptionsClick;
    let dffField = React.createRef();
    setTimeout(() => {
        $("#alernateNumberErrorMessage").hide();
        const platformType = GlobalStoreService.get("platformType");
        if (window.MyAirtelAppReact && platformType === PlatformType.ANDROID) {
            dffField.current.addEventListener("focus", (e) => {
                handleKeyBoardInApp(true);
            });
            dffField.current.addEventListener("blur", (e) => {
                handleKeyBoardInApp(false);
            });
        }
    }, 0);

    const handleKeyBoardInApp = (isFocussed) => {
        if (isFocussed) {
            $("#main").addClass("shift-up");
        } else {
            $("#main").removeClass("shift-up");
        }
    };

    const submitDff = () => {
        const regexp = /^\d{10}$/;
        if (!regexp.exec($("#alternateNumber").val())) {
            $("#alernateNumberErrorMessage").show();
            return;
        }
        $("#alernateNumberErrorMessage").hide();
        const dffData = {};
        // for (let i = 0; i < props.DFFFieldToBeDisplayed.length; i += 1) {
        //     let obj;
        //     if (props.DFFFieldToBeDisplayed[i].name === "Customer Lat/Long") {
        //         obj = {
        //             order: props.DFFFieldToBeDisplayed[i].ordering,
        //             value: props.additionalInfo.lat_long
        //                 ? props.additionalInfo.lat_long
        //                 : props.DFFFieldToBeDisplayed[i].defaultValue,
        //             name: props.DFFFieldToBeDisplayed[i].name
        //         };
        //     } else if (
        //         props.DFFFieldToBeDisplayed[i].name === "Problem Address & Landmark (M)" ||
        //         props.DFFFieldToBeDisplayed[i].name === "Problem Address(M)"
        //     ) {
        //         obj = {
        //             order: props.DFFFieldToBeDisplayed[i].ordering,
        //             value: props.additionalInfo.leapText
        //                 ? props.additionalInfo.leapText
        //                 : props.DFFFieldToBeDisplayed[i].defaultValue,
        //             name: props.DFFFieldToBeDisplayed[i].name
        //         };
        //     } else {
        //         obj = {
        //             order: props.DFFFieldToBeDisplayed[i].ordering,
        //             value: $("#alternateNumber").val()
        //                 ? $("#alternateNumber").val()
        //                 : props.DFFFieldToBeDisplayed[i].defaultValue,
        //             name: props.DFFFieldToBeDisplayed[i].name
        //         };
        //     }
        //     dffData[props.DFFFieldToBeDisplayed[i].name] = obj;

        //     const reqData = {
        //         transactionId: props.chatItem.scenarioResponse.transactionId,
        //         dffNameValuePairs: dffData,
        //         scenarioName: props.chatItem.scenarioResponse.scenario.scenarioName,
        //         notes: props.chatItem.scenarioResponse.notes,
        //         authToken: props.chatItem.scenarioResponse.authToken,
        //         crmCode: props.additionalInfo.crmCode
        //     };
        //     let additionalData = { reqData, ...props.additionalInfo }
        //     handleUserAction(new UserActionClass(UserActionType.CREATE_SR, null, null, null, null, additionalData))
        //     hideDffForm({});
        // }

        let obj;
        obj = {
            order: props.DFFFieldToBeDisplayed[0].ordering,
            value: $("#alternateNumber").val()
                ? $("#alternateNumber").val()
                : props.DFFFieldToBeDisplayed[0].defaultValue,
            name: props.DFFFieldToBeDisplayed[0].name
        };
        dffData[props.DFFFieldToBeDisplayed[0].name] = obj;

        const reqData = {
            transactionId: props.chatItem.scenarioResponse.transactionId,
            dffNameValuePairs: dffData,
            scenarioName: props.chatItem.scenarioResponse.scenario.scenarioName,
            notes: props.chatItem.scenarioResponse.notes,
            authToken: props.chatItem.scenarioResponse.authToken,
            crmCode: props.additionalInfo.crmCode
        };
        let additionalData = { reqData, ...props.additionalInfo }
        handleUserAction(new UserActionClass(UserActionType.CREATE_SR, null, null, null, null, additionalData))
        hideDffForm({});
    };

    const isValid = (event) => {
        $("#alernateNumberErrorMessage").hide();
        const regexp = /^\d{10}$/;
        if (event.which === 13 && regexp.exec(event.currentTarget.value)) {
            event.preventDefault();
            submitDff()
            return false;
        }
        if (
            (event.which !== 8 && event.which !== 0 && event.which < 48) ||
            event.which > 57
        ) {
            event.preventDefault();
            return false;
        }
        if (event.currentTarget.value.length > 9 || event.which === 13) {
            event.preventDefault();
            return false;
        }
        if (regexp.exec(event.currentTarget.value + event.key)) {
            $("#alernateNumberErrorMessage").hide();
            return true;
        } else {
            return false;
        }
    }

    const hideDffForm = ({ skip }) => {
        if (skip) {
            onSkipClick({ pop_count: 1 });
        }
        setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
    }

    return (
        <div id="dffForm" className="login-bar show" style={{ zIndex: '11111', height: 'auto', position: 'static' }}>
            <span className="text-right pr-20 fs-12 color-grey fs-light display-block pt-20 pb-10"><a href="javascript:void(0)"
                onClick={() => hideDffForm({ skip: true })}
                className="fs-12 color-grey fs-light"
            >
                Skip &rsaquo;
            </a></span>

            {/* DFF FORM FIELDS */}
            <label className="fs-11 color-light-grey fs-light pl-10 pt-5 pull-left border-bottom pb-5 uppercase">
                {(props &&
                    props.DFFFieldToBeDisplayed &&
                    props.DFFFieldToBeDisplayed.length > 0 &&
                    props.DFFFieldToBeDisplayed[0].displayNameChatbot) ?
                    props.DFFFieldToBeDisplayed[0].displayNameChatbot :

                    (props &&
                        props.DFFFieldToBeDisplayed &&
                        props.DFFFieldToBeDisplayed.length > 0 &&
                        props.DFFFieldToBeDisplayed[0].name) ?

                        props.DFFFieldToBeDisplayed[0].name : ""
                }</label>
            <input
                type="text"
                width="260"
                ref={dffField}
                id="alternateNumber"
                onKeyPress={isValid}
                placeholder={
                    (props &&
                        props.DFFFieldToBeDisplayed &&
                        props.DFFFieldToBeDisplayed.length > 0 &&
                        props.DFFFieldToBeDisplayed[0].displayNameChatbot) ?
                        props.DFFFieldToBeDisplayed[0].displayNameChatbot :

                        (props &&
                            props.DFFFieldToBeDisplayed &&
                            props.DFFFieldToBeDisplayed.length > 0 &&
                            props.DFFFieldToBeDisplayed[0].name) ?

                            props.DFFFieldToBeDisplayed[0].name : ""
                }
            />
            {/* Error Message */}
            <p className="pl-10" style={{ fontSize: '12px', color: 'red', padding: '10px' }} id="alernateNumberErrorMessage">Please enter a valid mobile number</p>

            <a
                href="javascript:void(0)"
                className="login-button fs-light color-white fs-13 pull-left"
                style={{ marginTop: 0 }}
                onMouseDown={() => {
                    submitDff()
                }
                }
            >SUBMIT
            </a>

        </div>
    )
}


export default AlternateNumberInputComponent


// WEBPACK FOOTER //
// ./src/components/bottom-components/alternate-number-input.component.js